import React from 'react';
import '../MatrixCompatibility/MarixMain.scss';
import Heart from '../../assets/heart1.png';
import Dollar from '../../assets/dollar1.png';

import { useAppSelector } from '../../hooks/redux';
import { IUserData, IUsersDataCompatibility } from '../../types';
import {
  getSum,
  largeCircleValue4,
  largeCircleValue5,
  largeCircleValue8,
  largeCircleValueCenter,
} from '../../functions/calculator';
import { AppointmentCompatibility } from '../AppointmentCompatibility/AppointmentCompatibility';

interface IMatrixCompatibilityProps {
  mainString1: string[];
  mainString2: string[];
  userData1: IUserData;
  userData2: IUserData;

  getCirclesValue: (mainString: string[], birth: string) => { [key: string]: number };
}

export const MatrixCompatibilityResult = ({
  mainString1,
  mainString2,
  userData1,
  userData2,
  getCirclesValue,
}: IMatrixCompatibilityProps) => {
  const { userDataPersonal, usersDataCompatibility } = useAppSelector(
    (state) => state.storeReducer
  );

  const LargeCenter = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
      getCirclesValue(mainString2, userData2.birth).circleLargeCenter
  );
  const Large1 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge1 +
      getCirclesValue(mainString2, userData2.birth).circleLarge1
  );
  const Large2 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge2 +
      getCirclesValue(mainString2, userData2.birth).circleLarge2
  );
  const Large3 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge3 +
      getCirclesValue(mainString2, userData2.birth).circleLarge3
  );
  const Large4 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge4 +
      getCirclesValue(mainString2, userData2.birth).circleLarge4
  );
  const Large5 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge5 +
      getCirclesValue(mainString2, userData2.birth).circleLarge5
  );
  const Large6 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge6 +
      getCirclesValue(mainString2, userData2.birth).circleLarge6
  );
  const Large7 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge7 +
      getCirclesValue(mainString2, userData2.birth).circleLarge7
  );
  const Large8 = getSum(
    getCirclesValue(mainString1, userData1.birth).circleLarge8 +
      getCirclesValue(mainString2, userData2.birth).circleLarge8
  );

  const dot04 = getSum(Large2 + Large4);
  const dot02 = getSum(Large4 + dot04);
  const dot01 = getSum(dot02 + Large4);
  const dot03 = getSum(dot04 + dot02);
  const dot06 = getSum(dot04 + Large2);
  const dot05 = getSum(dot04 + dot06);
  const dot07 = getSum(Large2 + dot06);

  const dot11 = getSum(Large2 + Large1);
  const dot09 = getSum(Large2 + dot11);
  const dot08 = getSum(Large2 + dot09);
  const dot10 = getSum(dot11 + dot09);
  const dot13 = getSum(Large1 + dot11);
  const dot12 = getSum(dot11 + dot13);
  const dot14 = getSum(dot13 + Large1);

  const dot18 = getSum(Large1 + Large3);
  const dot16 = getSum(Large1 + dot18);
  const dot15 = getSum(Large1 + dot16);
  const dot17 = getSum(dot16 + dot18);
  const dot20 = getSum(dot18 + Large3);
  const dot19 = getSum(dot18 + dot20);
  const dot21 = getSum(dot20 + Large3);

  const dot25 = getSum(Large3 + Large5);
  const dot23 = getSum(Large3 + dot25);
  const dot22 = getSum(Large3 + dot23);
  const dot24 = getSum(dot23 + dot25);
  const dot27 = getSum(dot25 + Large5);
  const dot26 = getSum(dot25 + dot27);
  const dot28 = getSum(dot27 + Large5);

  const dot32 = getSum(Large5 + Large7);
  const dot30 = getSum(Large5 + dot32);
  const dot29 = getSum(Large5 + dot30);
  const dot31 = getSum(dot32 + dot30);
  const dot34 = getSum(Large7 + dot32);
  const dot33 = getSum(dot32 + dot34);
  const dot35 = getSum(dot34 + Large7);

  const dot39 = getSum(Large7 + Large8);
  const dot37 = getSum(Large7 + dot39);
  const dot36 = getSum(Large7 + dot37);
  const dot38 = getSum(dot39 + dot37);
  const dot41 = getSum(Large8 + dot39);
  const dot40 = getSum(dot39 + dot41);
  const dot42 = getSum(dot41 + Large8);

  const dot46 = getSum(Large6 + Large8);
  const dot44 = getSum(Large8 + dot46);
  const dot43 = getSum(Large8 + dot44);
  const dot45 = getSum(dot46 + dot44);
  const dot48 = getSum(Large6 + dot46);
  const dot47 = getSum(dot46 + dot48);
  const dot49 = getSum(dot48 + Large6);

  const dot53 = getSum(Large4 + Large6);
  const dot51 = getSum(Large6 + dot53);
  const dot50 = getSum(Large6 + dot51);
  const dot52 = getSum(dot51 + dot53);
  const dot55 = getSum(Large4 + dot53);
  const dot54 = getSum(dot55 + dot53);
  const dot56 = getSum(dot55 + Large4);

  return (
    <div className="matrix_wrapper matrix-compatibility" id="matrix-result">
      <h3 id="h3_life-map">Cумісність пари</h3>
      <div className="circle circle_large" id="large-center">
        <div className="circle circle_large_inside" id="large-center_inside">
          {LargeCenter}
        </div>
      </div>
      <div className="circle circle_large" id="large-1">
        <div className="circle circle_large_inside" id="large-1_inside">
          {Large1}
        </div>
      </div>
      <div className="circle circle_large circle_large_not-inside" id="large-2">
        {Large2}
      </div>
      <div className="circle circle_large circle_large_not-inside" id="large-3">
        {Large3}
      </div>
      <div className="circle circle_large" id="large-4">
        <div className="circle circle_large_inside" id="large-4_inside">
          {Large4}
        </div>
      </div>
      <div className="circle circle_large" id="large-5">
        <div className="circle circle_large_inside" id="large-5_inside">
          {Large5}
        </div>
      </div>
      <div className="circle circle_large circle_large_not-inside" id="large-6">
        {Large6}
      </div>
      <div className="circle circle_large circle_large_not-inside" id="large-7">
        {Large7}
      </div>
      <div className="circle circle_large" id="large-8">
        <div className="circle circle_large_inside" id="large-8_inside">
          {Large8}
        </div>
      </div>
      {/*/!*<div className="circle circle_large" id="large_center-circle"></div>*!/*/}
      <div className="square" id="square-1"></div>
      <div className="square" id="square-2"></div>

      <hr id="hr_top-left" />
      <hr id="hr_top-right" />
      <hr id="hr_top-left-2" />
      <hr id="hr_top-right-2" />
      <hr id="hr_bot-left-2" />
      <hr id="hr_bot-right-2" />
      <hr id="hr_bot-left" />
      <hr id="hr_bot-right" />
      <hr id="hr_center-vertical" />
      <hr id="hr_center-horizontal" />
      <hr id="hr_dashed-result" />

      <hr id="hr_rotate-1" />
      <hr id="hr_rotate-2" />

      <p className="line" id="men-line">
        Лінія чоловічого роду
      </p>
      <p className="line" id="women-line">
        Лінія жіночого роду
      </p>

      <img className="heart" id="heart" src={Heart} alt="" />
      <img className="dollar" id="dollar" src={Dollar} alt="" />

      <div className="circle circle_medium" id="medium-1">
        <div className="circle circle_medium_inside" id="medium-1_inside">
          {getSum(
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge1 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge1
                )
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge1 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge1
              )
          )}
        </div>
      </div>
      {/*<div className="circle circle_medium" id="medium-2">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).mediumCircle2 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).mediumCircle2*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      {/*<div className="circle circle_medium" id="medium-3">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).mediumCircle3 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).mediumCircle3*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      <div className="circle circle_medium" id="medium-4">
        <div className="circle circle_medium_inside" id="medium-4_inside">
          {getSum(
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge4 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge4
                )
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge4 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge4
              )
          )}
        </div>
      </div>
      <div className="circle circle_medium circle_medium_not-inside" id="medium-5">
        {getSum(
          getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge5
              )
          ) +
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                getCirclesValue(mainString2, userData2.birth).circleLarge5
            )
        )}
      </div>
      {/*<div className="circle circle_medium" id="medium-6">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).mediumCircle6 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).mediumCircle6*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      {/*<div className="circle circle_medium" id="medium-7">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).mediumCircle7 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).mediumCircle7*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      <div className="circle circle_medium circle_medium_not-inside" id="medium-8">
        {getSum(
          getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge8
              )
          ) +
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                getCirclesValue(mainString2, userData2.birth).circleLarge8
            )
        )}
      </div>

      <div className="circle circle_small" id="small-1">
        <div className="circle circle_small_inside" id="small-1_inside">
          {getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge1 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge1
              )
          )}
        </div>
      </div>
      {/*<div className="circle circle_small" id="small-2">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).smallCircle2 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).smallCircle2*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      {/*<div className="circle circle_small" id="small-3">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).smallCircle3 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).smallCircle3*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      <div className="circle circle_small" id="small-4">
        <div className="circle circle_small_inside" id="small-4_inside">
          {getSum(
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge1 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge1
                )
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              )
          )}
        </div>
      </div>
      <div className="circle circle_small" id="small-5">
        <div className="circle circle_small_inside" id="small-5_inside">
          {getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge4 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge4
              )
          )}{' '}
        </div>
      </div>
      <div className="circle circle_small" id="small-6">
        <div className="circle circle_small_inside" id="small-6_inside">
          {getSum(
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge4 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge4
                )
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              )
          )}
        </div>
      </div>
      <div className="circle circle_small" id="small-7">
        <div className="circle circle_small_inside" id="small-7_inside">
          {getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge5
              )
          )}
        </div>
      </div>
      {/*<div className="circle circle_small" id="small-8">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).smallCircle8 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).smallCircle8*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      <div className="circle circle_small circle_small_not-inside" id="small-9">
        {getSum(
          getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge8
              )
          ) +
            getSum(
              getSum(
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                    getCirclesValue(mainString2, userData2.birth).circleLargeCenter
                ) +
                  getSum(
                    getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                      getCirclesValue(mainString2, userData2.birth).circleLarge5
                  )
              ) +
                getSum(
                  getSum(
                    getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                      getCirclesValue(mainString2, userData2.birth).circleLargeCenter
                  ) +
                    getSum(
                      getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                        getCirclesValue(mainString2, userData2.birth).circleLarge8
                    )
                )
            )
        )}{' '}
      </div>
      {/*<div className="circle circle_small" id="small-10">*/}
      {/*  {getSum(*/}
      {/*    getCirclesValue(mainString1, userData1.birth).smallCircle10 +*/}
      {/*      getCirclesValue(mainString2, userData2.birth).smallCircle10*/}
      {/*  )}{' '}*/}
      {/*</div>*/}
      <div className="circle circle_small circle_small_not-inside" id="small-11">
        {getSum(
          getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge5
              )
          ) +
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge8
                )
            )
        )}{' '}
      </div>
      <div className="circle circle_small circle_small_not-inside" id="small-12">
        {getSum(
          getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge5
              )
          ) +
            getSum(
              getSum(
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                    getCirclesValue(mainString2, userData2.birth).circleLargeCenter
                ) +
                  getSum(
                    getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                      getCirclesValue(mainString2, userData2.birth).circleLarge5
                  )
              ) +
                getSum(
                  getSum(
                    getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                      getCirclesValue(mainString2, userData2.birth).circleLargeCenter
                  ) +
                    getSum(
                      getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                        getCirclesValue(mainString2, userData2.birth).circleLarge8
                    )
                )
            )
        )}{' '}
      </div>
      <div className="circle circle_small" id="small-13">
        <div className="circle circle_small_inside" id="small-13_inside">
          {getSum(
            getSum(
              getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                getCirclesValue(mainString2, userData2.birth).circleLargeCenter
            ) +
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                  getCirclesValue(mainString2, userData2.birth).circleLarge8
              )
          )}
        </div>
      </div>
      <div className="circle circle_small circle_small_not-inside" id="small-14">
        {getSum(
          getSum(
            largeCircleValueCenter(mainString1, userData1.birth) +
              largeCircleValueCenter(mainString2, userData2.birth)
          ) +
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge5 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge5
                )
            )
        )}
      </div>
      <div className="circle circle_small circle_small_not-inside" id="small-15">
        {getSum(
          getSum(
            largeCircleValueCenter(mainString1, userData1.birth) +
              largeCircleValueCenter(mainString2, userData2.birth)
          ) +
            getSum(
              getSum(
                getCirclesValue(mainString1, userData1.birth).circleLargeCenter +
                  getCirclesValue(mainString2, userData2.birth).circleLargeCenter
              ) +
                getSum(
                  getCirclesValue(mainString1, userData1.birth).circleLarge8 +
                    getCirclesValue(mainString2, userData2.birth).circleLarge8
                )
            )
        )}
      </div>
      <div className="small-arrow arrow-right" id="arrow-1">
        <p className="years years_right" id="years-20">
          20 років
        </p>
      </div>
      <div className="small-arrow arrow-right" id="arrow-2">
        <p className="years years_right" id="years-30">
          30 років
        </p>
      </div>
      <div className="small-arrow arrow-right" id="arrow-3">
        <p className="years years_right" id="years-40">
          40 років
        </p>
      </div>
      <div className="small-arrow arrow-right" id="arrow-4">
        <p className="years years_right" id="years-50">
          50 років
        </p>
      </div>
      <div className="small-arrow arrow-left" id="arrow-5">
        <p className="years years_left" id="years-10">
          10 років
        </p>
      </div>
      <div className="small-arrow arrow-left" id="arrow-6">
        <p className="years years_left" id="years-0">
          0 років
        </p>
      </div>
      <div className="small-arrow arrow-left" id="arrow-7">
        <p className="years years_left" id="years-70">
          70 років
        </p>
      </div>
      <div className="small-arrow arrow-left" id="arrow-8">
        <p className="years years_left" id="years-60">
          60 років
        </p>
      </div>

      <div className="dot" id="dot-1">
        <div className="years-period">1-2</div>
        <div className="energy-value" id="1">
          {dot01}
        </div>
      </div>
      <div className="dot" id="dot-2">
        <div className="years-period">2-3</div>
        <div className="energy-value" id="2">
          {dot02}
        </div>
      </div>
      <div className="dot" id="dot-3">
        <div className="years-period">3-4</div>
        <div className="energy-value" id="3">
          {dot03}
        </div>
      </div>

      <div className="dot" id="dot-4">
        <div className="dot_inside">
          <div className="years-period">5 років</div>
          <div className="energy-value energy-value_center" id="5">
            {dot04}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-5">
        <div className="years-period">6-7</div>
        <div className="energy-value" id="6">
          {dot05}
        </div>
      </div>
      <div className="dot" id="dot-6">
        <div className="years-period">7-8</div>
        <div className="energy-value" id="7">
          {dot06}
        </div>
      </div>
      <div className="dot" id="dot-7">
        <div className="years-period">8-9</div>
        <div className="energy-value" id="7">
          {dot07}
        </div>
      </div>

      <div className="dot" id="dot-8">
        {/*<div className="years-period">11-12</div>*/}
        <div className="energy-value" id="9">
          {dot08}
        </div>
      </div>
      <div className="dot" id="dot-9">
        <div className="years-period">12-13</div>
        <div className="energy-value" id="10">
          {dot09}
        </div>
      </div>
      <div className="dot" id="dot-10">
        <div className="years-period">13-14</div>
        <div className="energy-value" id="11">
          {dot10}
        </div>
      </div>

      <div className="dot" id="dot-11">
        <div className="dot_inside">
          <div className="years-period">15 років</div>
          <div className="energy-value energy-value_center" id="12">
            {dot11}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-12">
        <div className="years-period">16-17</div>
        <div className="energy-value" id="13">
          {dot12}
        </div>
      </div>
      <div className="dot" id="dot-13">
        <div className="years-period">17-18</div>
        <div className="energy-value" id="14">
          {dot13}
        </div>
      </div>
      <div className="dot" id="dot-14">
        <div className="years-period">18-19</div>
        <div className="energy-value" id="15">
          {dot14}
        </div>
      </div>

      <div className="dot" id="dot-15">
        <div className="years-period">21-22</div>
        <div className="energy-value" id="17">
          {dot15}
        </div>
      </div>
      <div className="dot" id="dot-16">
        <div className="years-period">22-23</div>
        <div className="energy-value" id="18">
          {dot16}
        </div>
      </div>
      <div className="dot" id="dot-17">
        <div className="years-period">23-24</div>
        <div className="energy-value" id="19">
          {dot17}
        </div>
      </div>
      <div className="dot" id="dot-18">
        <div className="dot_inside">
          <div className="years-period">25 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot18}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-19">
        <div className="years-period">26-27</div>
        <div className="energy-value" id="1">
          {dot19}
        </div>
      </div>
      <div className="dot" id="dot-20">
        <div className="years-period">27-28</div>
        <div className="energy-value" id="1">
          {dot20}
        </div>
      </div>
      <div className="dot" id="dot-21">
        <div className="years-period">28-29</div>
        <div className="energy-value" id="1">
          {dot21}
        </div>
      </div>

      <div className="dot" id="dot-22">
        <div className="years-period">31-32</div>
        <div className="energy-value" id="1">
          {dot22}
        </div>
      </div>
      <div className="dot" id="dot-23">
        <div className="years-period">32-33</div>
        <div className="energy-value" id="1">
          {dot23}
        </div>
      </div>
      <div className="dot" id="dot-24">
        <div className="years-period">33-34</div>
        <div className="energy-value" id="1">
          {dot24}
        </div>
      </div>
      <div className="dot" id="dot-25">
        <div className="dot_inside">
          <div className="years-period">35 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot25}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-26">
        <div className="years-period">36-37</div>
        <div className="energy-value" id="1">
          {dot26}
        </div>
      </div>
      <div className="dot" id="dot-27">
        <div className="years-period">37-38</div>
        <div className="energy-value" id="1">
          {dot27}
        </div>
      </div>
      <div className="dot" id="dot-28">
        <div className="years-period">39-40</div>
        <div className="energy-value" id="1">
          {dot28}
        </div>
      </div>

      <div className="dot" id="dot-29">
        <div className="years-period">41-42</div>
        <div className="energy-value" id="1">
          {dot29}
        </div>
      </div>
      <div className="dot" id="dot-30">
        <div className="years-period">42-43</div>
        <div className="energy-value" id="1">
          {dot30}
        </div>
      </div>
      <div className="dot" id="dot-31">
        <div className="years-period">43-44</div>
        <div className="energy-value" id="1">
          {dot31}
        </div>
      </div>
      <div className="dot" id="dot-32">
        <div className="dot_inside">
          <div className="years-period">45 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot32}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-33">
        <div className="years-period">46-47</div>
        <div className="energy-value" id="1">
          {dot33}
        </div>
      </div>
      <div className="dot" id="dot-34">
        <div className="years-period">47-48</div>
        <div className="energy-value" id="1">
          {dot34}
        </div>
      </div>
      <div className="dot" id="dot-35">
        <div className="years-period">48-49</div>
        <div className="energy-value" id="1">
          {dot35}
        </div>
      </div>

      <div className="dot" id="dot-36">
        <div className="years-period">51-52</div>
        <div className="energy-value" id="1">
          {dot36}
        </div>
      </div>
      <div className="dot" id="dot-37">
        <div className="years-period">52-53</div>
        <div className="energy-value" id="1">
          {dot37}
        </div>
      </div>
      <div className="dot" id="dot-38">
        <div className="years-period">53-54</div>
        <div className="energy-value" id="1">
          {dot38}
        </div>
      </div>
      <div className="dot" id="dot-39">
        <div className="dot_inside">
          <div className="years-period">55 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot39}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-40">
        <div className="years-period">56-57</div>
        <div className="energy-value" id="1">
          {dot40}
        </div>
      </div>
      <div className="dot" id="dot-41">
        <div className="years-period">57-58</div>
        <div className="energy-value" id="1">
          {dot41}
        </div>
      </div>
      <div className="dot" id="dot-42">
        <div className="years-period">58-59</div>
        <div className="energy-value" id="1">
          {dot42}
        </div>
      </div>
      <div className="dot" id="dot-43">
        <div className="years-period">61-62</div>
        <div className="energy-value" id="1">
          {dot43}
        </div>
      </div>

      <div className="dot" id="dot-44">
        <div className="years-period">62-63</div>
        <div className="energy-value" id="1">
          {dot44}
        </div>
      </div>
      <div className="dot" id="dot-45">
        <div className="years-period">63-64</div>
        <div className="energy-value" id="1">
          {dot45}
        </div>
      </div>
      <div className="dot" id="dot-46">
        <div className="dot_inside">
          <div className="years-period">65 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot46}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-47">
        <div className="years-period">66-67</div>
        <div className="energy-value" id="1">
          {dot47}
        </div>
      </div>
      <div className="dot" id="dot-48">
        <div className="years-period">67-68</div>
        <div className="energy-value" id="1">
          {dot48}
        </div>
      </div>
      <div className="dot" id="dot-49">
        <div className="years-period">68-69</div>
        <div className="energy-value" id="1">
          {dot49}
        </div>
      </div>
      <div className="dot" id="dot-50">
        <div className="years-period">71-72</div>
        <div className="energy-value" id="1">
          {dot50}
        </div>
      </div>
      <div className="dot" id="dot-51">
        <div className="years-period">72-73</div>
        <div className="energy-value" id="1">
          {dot51}
        </div>
      </div>

      <div className="dot" id="dot-52">
        <div className="years-period">73-74</div>
        <div className="energy-value" id="1">
          {dot52}
        </div>
      </div>
      <div className="dot" id="dot-53">
        <div className="dot_inside">
          <div className="years-period">75 років</div>
          <div className="energy-value energy-value_center" id="1">
            {dot53}
          </div>
        </div>
      </div>
      <div className="dot" id="dot-54">
        <div className="years-period">76-77</div>
        <div className="energy-value" id="1">
          {dot54}
        </div>
      </div>
      <div className="dot" id="dot-55">
        <div className="years-period">77-78</div>
        <div className="energy-value" id="1">
          {dot55}
        </div>
      </div>
      <div className="dot" id="dot-56">
        <div className="years-period">78-79</div>
        <div className="energy-value" id="1">
          {dot56}
        </div>
      </div>

      {/**********************************************/}
      {/*<AppointmentCompatibility*/}
      {/*  mainString1={mainString1}*/}
      {/*  mainString2={mainString2}*/}
      {/*  userData1={usersDataCompatibility.user1}*/}
      {/*  userData2={usersDataCompatibility.user2}*/}
      {/*  getCirclesValue={getCirclesValue}*/}
      {/*/>*/}
      {/*<div className="purposes">*/}
      {/*  <h3>Призначення</h3>*/}
      {/*  <div className="purposes_top">*/}
      {/*    <div className="purpose personal">*/}
      {/*      <h3 className="purpose_h3">Особисте</h3>*/}

      {/*      <div className="rect">*/}
      {/*        <div className="content">*/}
      {/*          <div className="content_row">*/}
      {/*            Небо:*/}
      {/*            <div className="circle_purpose">*/}
      {/*              {getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge1 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge1*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge8 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge8*/}
      {/*                  )*/}
      {/*              )}*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*          <div className="content_row">*/}
      {/*            Земля:*/}
      {/*            <div className="circle_purpose">*/}
      {/*              {getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge4 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge4*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge5 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge5*/}
      {/*                  )*/}
      {/*              )}*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className="right-border">*/}
      {/*          <span className="span left-brace-tl"></span>*/}
      {/*          <span className="span left-brace-tr"></span>*/}
      {/*          <br />*/}
      {/*          <span className="span left-brace-bl"></span>*/}
      {/*          <span className="span left-brace-br"></span>*/}
      {/*        </div>*/}
      {/*        <div className="circle_purpose circle_sum">*/}
      {/*          {getSum(*/}
      {/*            getSum(*/}
      {/*              getSum(*/}
      {/*                getCirclesValue(mainString1, userData1.birth).circleLarge1 +*/}
      {/*                  getCirclesValue(mainString2, userData2.birth).circleLarge1*/}
      {/*              ) +*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge8 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge8*/}
      {/*                )*/}
      {/*            ) +*/}
      {/*              getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge4 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge4*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge5 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge5*/}
      {/*                  )*/}
      {/*              )*/}
      {/*          )}*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="purpose social">*/}
      {/*      <h3 className="purpose_h3">Соціальне</h3>*/}
      {/*      <div className="rect">*/}
      {/*        <div className="content">*/}
      {/*          <div className="content_row word">*/}
      {/*            <span className="word">Ч:</span>*/}
      {/*            <div className="circle_purpose">*/}
      {/*              {getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge2 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge2*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge7 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge7*/}
      {/*                  )*/}
      {/*              )}*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*          <div className="content_row word">*/}
      {/*            <span className="word">Ж:</span>*/}
      {/*            <div className="circle_purpose">*/}
      {/*              {getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge3 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge3*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge6 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge6*/}
      {/*                  )*/}
      {/*              )}*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className="right-border">*/}
      {/*          <span className="span left-brace-tl"></span>*/}
      {/*          <span className="span left-brace-tr"></span>*/}
      {/*          <br />*/}
      {/*          <span className="span left-brace-bl"></span>*/}
      {/*          <span className="span left-brace-br"></span>*/}
      {/*        </div>*/}
      {/*        <div className="circle_purpose circle_sum">*/}
      {/*          {getSum(*/}
      {/*            getSum(*/}
      {/*              getSum(*/}
      {/*                getCirclesValue(mainString1, userData1.birth).circleLarge2 +*/}
      {/*                  getCirclesValue(mainString2, userData2.birth).circleLarge2*/}
      {/*              ) +*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge7 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge7*/}
      {/*                )*/}
      {/*            ) +*/}
      {/*              getSum(*/}
      {/*                getSum(*/}
      {/*                  getCirclesValue(mainString1, userData1.birth).circleLarge3 +*/}
      {/*                    getCirclesValue(mainString2, userData2.birth).circleLarge3*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge6 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge6*/}
      {/*                  )*/}
      {/*              )*/}
      {/*          )}*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="purpose purpose_bottom">*/}
      {/*    <div className="purpose_general">*/}
      {/*      <h3 className="purpose_h3">Духовне</h3>*/}
      {/*      <div className="">*/}
      {/*        <div className="content circle_solo">*/}
      {/*          <div className="circle">*/}
      {/*            {getSum(*/}
      {/*              getSum(*/}
      {/*                getSum(*/}
      {/*                  getSum(*/}
      {/*                    getCirclesValue(mainString1, userData1.birth).circleLarge2 +*/}
      {/*                      getCirclesValue(mainString2, userData2.birth).circleLarge2*/}
      {/*                  ) +*/}
      {/*                    getSum(*/}
      {/*                      getCirclesValue(mainString1, userData1.birth).circleLarge7 +*/}
      {/*                        getCirclesValue(mainString2, userData2.birth).circleLarge7*/}
      {/*                    )*/}
      {/*                ) +*/}
      {/*                  getSum(*/}
      {/*                    getSum(*/}
      {/*                      getCirclesValue(mainString1, userData1.birth).circleLarge3 +*/}
      {/*                        getCirclesValue(mainString2, userData2.birth).circleLarge3*/}
      {/*                    ) +*/}
      {/*                      getSum(*/}
      {/*                        getCirclesValue(mainString1, userData1.birth).circleLarge6 +*/}
      {/*                          getCirclesValue(mainString2, userData2.birth).circleLarge6*/}
      {/*                      )*/}
      {/*                  )*/}
      {/*              ) +*/}
      {/*                getSum(*/}
      {/*                  getSum(*/}
      {/*                    getSum(*/}
      {/*                      getCirclesValue(mainString1, userData1.birth).circleLarge1 +*/}
      {/*                        getCirclesValue(mainString2, userData2.birth).circleLarge1*/}
      {/*                    ) +*/}
      {/*                      getSum(*/}
      {/*                        getCirclesValue(mainString1, userData1.birth).circleLarge8 +*/}
      {/*                          getCirclesValue(mainString2, userData2.birth).circleLarge8*/}
      {/*                      )*/}
      {/*                  ) +*/}
      {/*                    getSum(*/}
      {/*                      getSum(*/}
      {/*                        getCirclesValue(mainString1, userData1.birth).circleLarge4 +*/}
      {/*                          getCirclesValue(mainString2, userData2.birth).circleLarge4*/}
      {/*                      ) +*/}
      {/*                        getSum(*/}
      {/*                          getCirclesValue(mainString1, userData1.birth).circleLarge5 +*/}
      {/*                            getCirclesValue(mainString2, userData2.birth).circleLarge5*/}
      {/*                        )*/}
      {/*                    )*/}
      {/*                )*/}
      {/*            )}*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};
